import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import "core-js/modules/es6.regexp.replace";
import "core-js/modules/es6.string.trim";
import "core-js/modules/es6.regexp.match";
import _slicedToArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import "core-js/modules/es6.array.map";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.from";
import "core-js/modules/es6.array.filter";
var breakpoints = {
  smallPhone: 320,
  phone: 375,
  tablet: 768,
  desktop: 1024,
  largeDesktop: 1440
};
var signRegex = /^[<=>]+/;

function throwError() {
  throw "invalid media-query  :(";
}

function cssinjsMedia() {
  var validatedQuery = Array.from(arguments).filter(checkValid);
  var isValid = Array.from(arguments).length === validatedQuery.length;
  return isValid ? "@media " + validatedQuery.map(convertToQuery).join(" and ") : throwError();
}

function checkValid(param) {
  var _parseParam = parseParam(param),
      _parseParam2 = _slicedToArray(_parseParam, 2),
      sign = _parseParam2[0],
      screenSize = _parseParam2[1];

  var checkResult = Boolean(sign) && Boolean(breakpoints[screenSize]);
  return checkResult;
}

function parseParam(param) {
  var sign = param.match(signRegex) ? param.match(signRegex)[0].trim() : "";
  var screenSize = param.replace(signRegex, "").trim();
  return [sign, screenSize];
}

function convertToQuery(param) {
  var _parseParam3 = parseParam(param),
      _parseParam4 = _slicedToArray(_parseParam3, 2),
      sign = _parseParam4[0],
      screenSize = _parseParam4[1];

  var hasEqualSign = sign.includes("=");
  var size = hasEqualSign ? breakpoints[screenSize] : breakpoints[screenSize] - 1;
  var widthCondition = sign.includes(">") ? "min-width" : "max-width";
  return "(".concat(widthCondition, ": ").concat(size, "px)");
}

export default cssinjsMedia;